import { YOUTUBE_PATHS } from '@constants/YOUTUBE';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

const SUBCRIBER_CLASSNAMES = {
    default: 'font-DM-Sans leading-34px',
    twitter: 'font-Inter leading-34px',
    youtube: 'font-Inter leading-30px',
};

const SUBCRIBER_BORDER_COLOR_BY_BRAND = {
    default: '',
    youtube: 'border-color-youtube',
};

const SUBCRIBER_CLASSNAMES_MAX_WIDTH_HEAD = {
    default: 'px-5 md:px-35px xl:container',
    twitter: 'px-5 md:px-35px xl:container',
};

const CLASSNAMES_BTN_START_PROMOTION = {
    default: 'md:text-sm text-16px font-Inter font-semibold mt-6 md:mt-35px',
    twitter:
        'text-15px md:font-semibold font-bold md:font-Inter font-DM-Sans mt-4 w-149px p-0',
    instagram: 'text-base md:text-15px mt-6 md:mt-35px font-Inter',
    youtube:
        'font-semibold mt-6 md:mt-35px text-base md:text-15px font-DM-Sans',
};

const SUBCRIBER_TEXT_GROW = {
    default: 'Subscribers',
    twitter: 'Followers & Like',
    twitch: 'Twitch Fast',
};

const SUBCRIBER_COLOR = {
    youtube: '#F0C015',
    twitter: '#03A9F4',
    twitch: '#791FF4',
    tiktok: '#069A8E',
    instagram: '#9254C8',
};

const SUBCRIBER_COLOR_BRAND = {
    twitter: 'text-violet-twitter',
    twitch: 'text-violet-twitch',
    tiktok: 'text-green-tiktok',
    instagram: 'text-violet-instagram-svg',
    youtube: 'text-yellow-moon-svg',
    default: 'text-red-400',
};

export const useSubsciberClass = (brand?: string) => {
    const router = useRouter();

    const className = useMemo(() => {
        const brandLink = brand
            ? brand
            : router.pathname.split('/')[1] || 'default';

        return (
            SUBCRIBER_CLASSNAMES[brandLink] || SUBCRIBER_CLASSNAMES['default']
        );
    }, [router.pathname, brand]);

    return className;
};

export const useClassBtnStartPromotion = () => {
    const router = useRouter();

    const className = useMemo(() => {
        const brand = router.pathname.split('/')[1] || 'default';
        let brandName = brand;
        if (['/youtube'].indexOf(router.pathname) > -1) {
            brandName = 'youtube';
        }
        return (
            CLASSNAMES_BTN_START_PROMOTION[brandName] ||
            CLASSNAMES_BTN_START_PROMOTION['default']
        );
    }, [router.pathname]);

    return className;
};

export const useClassMaxWidthHead = () => {
    const router = useRouter();

    const className = useMemo(() => {
        const brand = router.pathname.split('/')[1] || 'default';
        return (
            SUBCRIBER_CLASSNAMES_MAX_WIDTH_HEAD[brand] ||
            SUBCRIBER_CLASSNAMES_MAX_WIDTH_HEAD['default']
        );
    }, [router.pathname]);

    return className;
};

export const useTextGrow = () => {
    const router = useRouter();
    const result = useMemo(() => {
        const brand = router.pathname.split('/')[1] || 'default';
        return SUBCRIBER_TEXT_GROW[brand] || SUBCRIBER_TEXT_GROW['default'];
    }, [router.pathname]);

    return result;
};

export const useColor = () => {
    const router = useRouter();
    const result = useMemo(() => {
        const brand = router.pathname.split('/')[1];
        const brandYoutube = YOUTUBE_PATHS.indexOf(`/${brand}`) > -1;
        let brandLink = brand;

        if (brandYoutube) {
            brandLink = 'youtube';
        }
        return SUBCRIBER_COLOR[brand] || SUBCRIBER_COLOR['youtube'];
    }, [router.pathname]);

    return result;
};

export const useBorderColorByBrand = () => {
    const router = useRouter();

    const className = useMemo(() => {
        const brand = router.pathname.split('/')[1];
        const brandYoutube = YOUTUBE_PATHS.indexOf(`/${brand}`) > -1;
        let brandLink = brand;
        if (
            brandYoutube ||
            (router.pathname.includes('[id]') && brand === 'complete-order')
        ) {
            brandLink = 'youtube';
        }
        return (
            SUBCRIBER_BORDER_COLOR_BY_BRAND[brandLink] ||
            SUBCRIBER_BORDER_COLOR_BY_BRAND['default']
        );
    }, [router.pathname]);

    return className;
};

export const useTextColorByBrand = () => {
    const router = useRouter();

    const className = useMemo(() => {
        const brand = router.pathname.split('/')[1];
        const brandYoutube = YOUTUBE_PATHS.indexOf(`/${brand}`) > -1;
        let brandLink = brand;
        if (
            brandYoutube ||
            (router.pathname.includes('[id]') && brand === 'complete-order')
        ) {
            brandLink = 'youtube';
        }
        return (
            SUBCRIBER_COLOR_BRAND[brandLink] || SUBCRIBER_COLOR_BRAND['default']
        );
    }, [router.pathname]);

    return className;
};
